#@import _
#@import Booking.Views.Base
#@export Booking.Views.Collection

class Booking.Views.Collection extends Booking.Views.Base

  containerSelector: '[yield]'

  emptyContainerSelector: '[yield-empty]'

  constructor: ->
    Booking.Views.Base.apply this, arguments
    @listenTo @collection, 'reset', => @render()
    @listenTo @collection, 'sort', => @render()

  container: ->
    @_container(@containerSelector, @$el)

  emptyContainer: ->
    @_container(@emptyContainerSelector, null)

  _container: (selector, defaultElement) ->
    container = @$el.find(selector)
    if container.length
      container
    else
      defaultElement

  render: ->
    if @templateName
      Booking.Views.Base::render.apply this, arguments

    @clearContainer()

    models = @getModels()

    if models.length > 0
      @emptyContainer()?.hide()
      @container().show()

      limit = Math.min(@options.limit || models.length, models.length)
      for model in models.slice(0, limit)
        @appendChildView(model)
    else
      @container().hide()
      @emptyContainer()?.show()

    this

  getModels: ->
    @collection.models

  clearContainer: ->
    @container().html('')

  appendChildView: (model) ->
    @renderChildView('append', model)

  renderChildView: (insert, model) ->
    options =
      model: model
      id: model?.id
      parentModel: @options.model if @options.model

    childView = new @childView _.extend({}, _.omit(@options, 'el'), options)
    childView.on 'all', @bubbleUpEvent, this

    @container()[insert] childView.render().el

    this

  # removeChildView: (model) ->
  #   $container = @container()
  #   $container.find("##{model.id}").remove()

  #   $emptyContainer = @emptyContainer()

  #   if $emptyContainer
  #     isEmpty = @getModels().length is 0
  #     $container.toggle(!isEmpty)
  #     $emptyContainer.toggle(isEmpty)

  bubbleUpEvent: ->
    @trigger.apply this, arguments
